import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { registerUser } from "../actions/register";
import styled from "styled-components";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
      overflow: "hidden",
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "55%",
    marginLeft: "30px",
    marginRight: "15px",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 2),
  },
  back: {
    "background-image": `url(${process.env.PUBLIC_URL}/images/2.png)`,
    "background-repeat": "no-repeat",
    "background-size": "cover",
    height: "90vh",
    "background-position": "center",
    overflow: "hidden",
  },
}));

function Register({ dispatch, error, user }) {
  const classes = useStyles();
  const [done, setDone] = React.useState(false)
  const [values, setValues] = React.useState({
    username: "",
    email: "",
    phone: "",
  });


  const handleClick = (event) => {
    event.preventDefault();
    const { email, username, phone } = values;
    if (username && email && phone) {
        dispatch(
            registerUser({
              username,
              email,
              phone,
            })
        );
        setDone(true)
    }
  };

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const emailValid = values.email.indexOf('@') > -1
  const phoneValid = values.phone !== '' && values.phone !== '+7'

  return (
    <Grid container spacing={8} style={{ overflow: "hidden" }}>
      <Grid xs={12} sm={6}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Register
            </Typography>
            <form className={classes.form} onSubmit={handleClick} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="email"
                label="email"
                id="email"
                value={values.name}
                onChange={handleChange("email")}
                autoFocus
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="username"
                label="username"
                username="username"
                value={values.name}
                onChange={handleChange("username")}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="phone"
                label="phone"
                name="phone"
                value={values.name}
                onChange={handleChange("phone")}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                disabled={!values.username || !values.email || done || !emailValid || !phoneValid}
              >
                Register
              </Button>

              {done && (
                <Typography style={{ color: "green", textAlign: "center" }}>
                  Thank you! We will contact you soon
                </Typography>
              )}
            </form>
          </div>
        </Container>
      </Grid>
      <Grid xs={12} sm={6}>
        <div className={classes.back}></div>
      </Grid>
    </Grid>
  );
}
const mapStateToProps = (state) => state.register;

export default connect(mapStateToProps)(Register);
